<template>
	<div class="custom-control custom-switch">
		<input
			:name="name"
			type="checkbox"
			class="custom-control-input"
			ref="checkbox1_input"
			:id="checkbox1_id"
			:value="true"
			@change="checkChanged" />
		<label class="custom-control-label" :for="checkbox1_id">{{ label }}</label>
	</div>
</template>

<script>
	import { uniqueId } from 'lodash';

	export default {
		props: {
			checked: {
				type: Boolean,
				default: false,
			},
			label: {
				default: '',
			},
			name: {
				default: 'checkbox',
			},
		},

		watch: {
			checked: function (newVal) {
				this.$refs.checkbox1_input.checked = newVal;
			},
		},

		data() {
			return {
				checkbox1_id: uniqueId('id'),
			};
		},

		methods: {
			checkChanged($event) {
				this.$emit('input', $event.target.checked);
				this.$emit('update:checked', $event.target.checked);
			},
		},
	};
</script>
